import { media } from '@/styles/breakpoints';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[2]};
`;

export const Number = styled.span`
  font-size: ${({ theme }) => theme.fontSizes['4xl']};
  font-weight: ${({ theme }) => theme.fontWeights.extrabold};
  line-height: 1;
  letter-spacing: ${({ theme }) => theme.letterSpacings.tighter};
  color: white;
  font-variant-numeric: tabular-nums;

  ${media.tablet} {
    font-size: ${({ theme }) => theme.fontSizes['5xl']};
  }
`;

export const Suffix = styled.span`
  color: ${({ theme }) => theme.colors.cyan[400]};
`;

export const Label = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: ${({ theme }) => theme.letterSpacings.wide};
  text-transform: uppercase;
`;
